<template>
  <div class="products">
    <img :src="banner" class="banner" />
    <div v-show="false" class="mould-tab">
      <div @click="scrollLeft">
        <div class="scroller-left"><i class="el-icon-arrow-left"></i></div>
      </div>
      <div class="tab-scroll-wrapper">
        <div
          ref="tabsWrapper"
          class="tabs-wrapper"
          :style="`margin-left: ${margin}px`"
        >
          <div @click="selectedCategory = 'All Mould'">
            <div
              :class="
                selectedCategory === 'All Mould'
                  ? 'tab-item-selected'
                  : 'tab-item'
              "
            >
              All Mould
            </div>
            <div v-if="selectedCategory === 'All Mould'" class="triangle"></div>
          </div>
          <div v-for="category in categories" :key="category">
            <div
              v-if="typeof category === 'string'"
              @click="selectedCategory = category"
            >
              <div
                :class="
                  selectedCategory === category
                    ? 'tab-item-selected'
                    : 'tab-item'
                "
              >
                {{ category }}
              </div>
              <div v-if="selectedCategory === category" class="triangle"></div>
            </div>
            <div v-else>
              <div
                v-for="subCategory in Object.keys(category)"
                :key="subCategory"
                @click="selectedCategory = subCategory"
              >
                <div
                  :class="
                    selectedCategory === subCategory
                      ? 'tab-item-selected'
                      : 'tab-item'
                  "
                >
                  {{ subCategory }}
                </div>
                <div
                  v-if="selectedCategory === subCategory"
                  class="triangle"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @mousedown="scrollRight">
        <div class="scroller-right"><i class="el-icon-arrow-right"></i></div>
      </div>
    </div>

    <el-row>
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <div class="title">Recommended for you</div>

        <div>
          <MouldExhibition
            :moulds="listOfCategories"
            :type="typeKey"
            :loose="true"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import "./_Products.scss";
import categoryOfMould from "../../static/categoryOfMould";
import { mouldCategories } from "../../static/data";
import MouldExhibition from "../../components/FullCategory/MouldExhibition";
export default {
  name: "Products",
  components: { MouldExhibition },
  props: {},
  data() {
    return {
      mouldCategories,
      selectedCategory: "All Mould",
      mouldType: this.$route.query.mouldType,
      margin: 0,
    };
  },
  computed: {
    MouldDataOfSelected() {
      const [MouldDataOfSelected] = this.mouldCategories.filter(
        (item) => item.title === this.mouldType
      );
      return MouldDataOfSelected;
    },
    typeKey() {
      const [MouldDataOfSelected] = this.mouldCategories.filter(
        (item) => item.title === this.mouldType
      );
      return MouldDataOfSelected.id;
    },
    listOfCategories() {
      console.log("moulds", this.MouldDataOfSelected.moulds);
      return this.MouldDataOfSelected.moulds;
    },
    banner() {
      return this.MouldDataOfSelected.banner;
    },
    categories() {
      console.log(
        "categoryOfMould[this.mouldType]",
        categoryOfMould[this.mouldType]
      );
      return categoryOfMould[this.mouldType];
    },
  },
  methods: {
    scrollRight() {
      const tabsWrapper = this.$refs.tabsWrapper;
      if (tabsWrapper.scrollWidth > tabsWrapper.clientWidth) {
        this.margin = this.margin - 20;
      }
    },
    scrollLeft() {
      this.margin = this.margin + 20 > 0 ? 0 : this.margin + 20;
    },
  },
};
</script>
